import React, {PropTypes} from "react";

import {FormattedMessage} from 'react-intl';

class Social extends React.Component {
  constructor(props) {
    super(props);
    this.empty = '';

  }

  checkSocial() {
    this.social = this.props.social;
    let value = [];
    for (let key in this.social) {
      if (this.social[key] !== '') {
        value.push(key);
      }
    }
    if (value.length !== 0) {
      this.empty = 'active';
    }
    return value;
  }

  render() {
    let socials = this.checkSocial().map((item) => {
      return this.social[item] ? (
        <li key={'social-' + item}>
          <a target="_blank" href={this.social[item]} className={"social social-" + item}/>
        </li>
      ): null;
    });
    return (
      <div className={'social-wrapper' + ' ' + this.empty}>
        <FormattedMessage id="follow_text">
          {(message) => <h5>{message}:</h5>}
        </FormattedMessage>
        <ul className="inline-list">{socials}</ul>
        {this.props.children}
      </div>
    );
  }
}

Social.propTypes = {
  children: PropTypes.object,
  social: PropTypes.object
};

export default Social;




/** WEBPACK FOOTER **
 ** ./src/components/nav/Social.js
 **/